// extracted by mini-css-extract-plugin
export default {"FcmDialogContent":"FcmImage_FcmDialogContent_WvZ6t","FcmDialogContentPdf":"FcmImage_FcmDialogContentPdf_GfzI5"};